import React, { FC } from 'react';
import {
  Box,
  Button,
  IconButton,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';
import { NavLink } from 'react-router-dom';
import { FiChevronLeft } from 'react-icons/fi';
import { LoadingButton } from '@mui/lab';
import { useUnit } from 'effector-react';
import css from '../../styles.module.scss';
import { addressesORD } from '../../../../../addresses';
import Header from '../../../../../components/Header';
import {
  $campaign,
  $changedAllForm,
  $disabledAllForm,
  $pendingAllForms,
  onResetALlForm,
  onSubmitALlForm,
} from '../model';

export const UpdateHeader: FC = () => {
  const campaign = useUnit($campaign);
  const pendingUpdate = useUnit($pendingAllForms);
  const [disabledAllForm, changedAllForm] = useUnit([
    $disabledAllForm,
    $changedAllForm,
  ]);
  const theme = useTheme();
  return (
    <Header>
      <Box display="flex">
        <NavLink to={addressesORD.campaignsPath}>
          <Tooltip title="Назад">
            <IconButton>
              <FiChevronLeft size={20} />
            </IconButton>
          </Tooltip>
        </NavLink>
        <Box flex={1}>
          <Typography
            className={css.name}
            variant="h1"
            sx={{
              marginLeft: '2px',
            }}
            title={campaign?.name}
          >
            Кампания {campaign?.name}
          </Typography>
          <Typography
            mt={0.5}
            sx={{
              color: theme.palette.secondary.light,
            }}
          >
            {campaign?.uuid}
          </Typography>
        </Box>
      </Box>
      <Box display="flex" alignItems="center" justifyContent="flex-end">
        <Button
          variant="outlined"
          disabled={!changedAllForm || pendingUpdate}
          sx={{
            marginLeft: pendingUpdate ? '36px' : '0px',
          }}
          onClick={() => onResetALlForm()}
        >
          Отмена
        </Button>
        <LoadingButton
          variant="contained"
          type="submit"
          disabled={disabledAllForm}
          onClick={() => onSubmitALlForm()}
          loading={pendingUpdate}
          sx={{
            marginLeft: '36px',
          }}
        >
          Сохранить
        </LoadingButton>
      </Box>
    </Header>
  );
};
